import { render, staticRenderFns } from "./ContentMetadata.vue?vue&type=template&id=18420722&scoped=true&"
import script from "./ContentMetadata.vue?vue&type=script&lang=ts&"
export * from "./ContentMetadata.vue?vue&type=script&lang=ts&"
import style0 from "./ContentMetadata.vue?vue&type=style&index=0&id=18420722&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18420722",
  null
  
)

export default component.exports